import { render } from "./OtherReports.vue?vue&type=template&id=c324280a&scoped=true&ts=true"
import script from "./OtherReports.vue?vue&type=script&lang=ts"
export * from "./OtherReports.vue?vue&type=script&lang=ts"

import "./OtherReports.vue?vue&type=style&index=0&id=c324280a&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c324280a"]])

export default __exports__